import React from 'react';
import { useParams } from 'react-router-dom';

import { NoteView } from '../components/note-view/note-view';

export function NoteViewPage() {
  const { name } = useParams<{ name: string }>();
  return <NoteView name={name} />;
}
